export default __webpack_public_path__ + "static/media/Voittaja_Asiakas.db9b9049.gif";